// extracted by mini-css-extract-plugin
export default {"modalContainer":"r1-z","modalIndicator":"s1-z","prevBtn":"t1-z","nextBtn":"u1-z","body":"v1-z","footer":"w1-z"};